import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CartList from './CartList';
import { useDispatch, useSelector } from 'react-redux';
import { openCart } from '../../app/cart/Cart';

const style = {
    position: 'absolute',
    height: '100%',
    top: '0',
    right: '0',
    bgcolor: 'background.paper',
    paddingTop: '50px'
};

export default function CartModal() {
        const dispatch = useDispatch();

    const { open } = useSelector((state) => state.cart);
    const handleClose = () => {
            dispatch(openCart(false))
        }
    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <CartList />
                </Box>
            </Modal>
        </div>
    );
}